module.exports = __webpack_public_path__ + "img/UtilityTechBackgroundC06_ua.82ab02f2.webp";